import React, {memo, useState} from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Typography, makeStyles, Checkbox, FormControl, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import clsx from "clsx";
import { remCalc } from "../../utils/helpers";


const useStyles = makeStyles(theme => ({
  root: {
    zIndex: "1310 !important"
  },
  title: {
    fontSize: "1.125rem",
    lineHeight: "1․25rem",
    fontWeight: 500,
    color: "#202124"
  },
  btnDelete: {
    color: "#FFF",
    textTransform: "none",
    boxShadow: "none !important",
    minWidth: remCalc(51),
    backgroundColor: theme.palette.error.main,

    "&:hover": {
      backgroundColor: "#B6281E !important",
      color: "#fff"
    }
  },
  btnSave: {
    color: "#FFF",
    textTransform: "none",
    boxShadow: "none !important",
    minWidth: remCalc(51),
    backgroundColor: theme.palette.primary.main,

    "&:hover": {
      backgroundColor: "#0114CB !important",
      color: "#fff"
    }
  },
  btnCancel: {
    color: "#4D4D50",
    minWidth: remCalc(63),
    marginRight: theme.spacing(1),
    backgroundColor: "unset !important",
    "&:hover": {
      backgroundColor: "rgba(32, 33, 36, 0.04) !important"
    }
  },
  btnActionCancel: {
    backgroundColor: "transparent !important",
    color: `${theme.palette.secondary.main} !important`
  },
  dialogCheckbox: {
    "&.Mui-checked > span > .MuiSvgIcon-root": {
       color: theme.palette.primary.main
    }
  },
  radioBtn: {
    "&.Mui-checked > span > div > .MuiSvgIcon-root": {
      color: theme.palette.primary.main
   }
  }
}));

function ConfirmDialog({
  isProject,
  open,
  handleClose,
  onCancel = () => {},
  action,
  title,
  body,
  cancelText = "Cancel",
  confirmText = "Delete",
  disableBackdropClick = false,
  actionDisabled = false,
  cancelDisabled = false,
  modalType
}) {
  const classes = useStyles();

  const [dialogState, setDialogState] = useState({
    checked: true,
    selectedValue: "reoptimize_routes_that_have_not_started"
  });

  const handleAction = (e) => {
    action(e, dialogState);
    handleClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      classes={{ root: classes.root }}
      // disableBackdropClick
      onClose={() => {
        // onClose();
        !disableBackdropClick && handleClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={disableBackdropClick}
    >
      <Box className={classes.title} px={3} pt={3} pb={2}>
        {title}
      </Box>

      <Box pb={1.25} px={3}>
        <Typography variant="body2">{body}</Typography>
      </Box>
      {modalType === "withCheckbox" && (
        <Box display="flex" pl={4}>
          <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={dialogState?.checked}
                    onChange={e => setDialogState({...dialogState, checked: !dialogState?.checked})}
                    className={classes.dialogCheckbox}
                    defaultChecked
                  />
                }
                label="Yes, try to fit these into my routes"
              />
          </FormControl>
       </Box>
      )}

      {modalType === "withRadioGroup" && (
         <Box display="flex" pl={4} pb={1}>
            <FormControl>
              <RadioGroup
                aria-labelledby="radio-buttons-group"
                name="radio-buttons-group"
                defaultValue={"reoptimize_routes_that_have_not_started"}
                value={dialogState.selectedValue}
                  onChange={e => {
                    setDialogState({
                    ...dialogState,
                    selectedValue: e.target.value
                  })
                }
              }
              >
                <FormControlLabel value="reoptimize_routes_that_have_not_started" control={<Radio  className={classes.radioBtn} />} label="Only reoptimize routes that haven’t been started" />
                <FormControlLabel value="reoptimize_all_started" control={<Radio className={classes.radioBtn}  />} label="Reoptimize all routes, even those already started" />
              </RadioGroup>
            </FormControl>
        </Box>
      )}

      <DialogActions>
        <Button
          onClick={() => {
            handleClose();
            onCancel();
          }}
          color="primary"
          autoFocus={!isProject || !modalType}
          data-cy="cancel-alertDialog"
          className={clsx({
            [classes.btnCancel]: isProject,
            [classes.btnActionCancel]: !!modalType
          })}
          disabled={cancelDisabled}
        >
          {cancelText}
        </Button>

        <Button
          onClick={handleAction}
          color="primary"
          data-cy="accept-alertDialog"
          autoFocus={!!modalType}
          className={clsx({
            [classes.btnDelete]: isProject,
            [classes.btnSave]: !!modalType 
          })}
          disabled={actionDisabled}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default memo(ConfirmDialog);
